import BaseModel from "../base_model.js";

import { InputLabelDisplayModeAbove } from "../../base/inputs/constants.js";

class RawSupportMessageModel extends BaseModel {

  rawFormFields(item = undefined) {
    return [
      {
        name: "name",
        displayName: this.fieldDisplayName("name"),
        type: "text",
        displayNamePosition: InputLabelDisplayModeAbove,
        weight: 6
      },
      {
        name: "email",
        displayName: this.fieldDisplayName("email"),
        type: "email",
        displayNamePosition: InputLabelDisplayModeAbove,
        weight: 6
      },
      {
        name: "subject",
        displayName: this.fieldDisplayName("subject"),
        type: "text",
        displayNamePosition: InputLabelDisplayModeAbove,
        forceNextLine: true,
        weight: 6
      },
      {
        name: "body",
        displayName: this.fieldDisplayName("body"),
        type: "text",
        displayNamePosition: InputLabelDisplayModeAbove,
        multiline: true
      },
    ]
  }

  i18nScope() {
    return "model.support.message";
  }

}
const SupportMessageModel = new RawSupportMessageModel();

export { RawSupportMessageModel, SupportMessageModel }

